/*
Author : Arman Ali
Module: Shared State
github: https://github.com/Arman-Arzoo
*/

import { createAsyncThunk } from '@reduxjs/toolkit';
import apiInstance from '../../Apis/Axios';
import axios from 'axios';
import {URL} from '../../Apis/Constants';

// List all the Employee
export const UploadImage = createAsyncThunk('sharedSlice/uploadImage', async (params, { dispatch, getState }) => {
    const result = await apiInstance
        .put('image-service/upload', params)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;
    return { data, status };
});

export const PublicUploadImage = createAsyncThunk(
    'sharedSlice/publicUploadImage', async (params, { dispatch, getState, rejectWithValue }) => {
        try {
            const response = await axios.put(`${URL}image-service/public-upload`, params);
            return response.data;
        } catch (error) {
            console.error("Upload error", error);
            return rejectWithValue(error.response?.data || "Upload failed");
        }
    }
);

